import { z } from "zod";
import countries from "../../../vendor/countries";

export const CountryCode = z.enum(Object.keys(countries) as [keyof typeof countries]);
export type CountryCode = z.infer<typeof CountryCode>;
